import { ISchema, PaywallComponentProps } from '../../@types'
import { mergeDeep } from '@/helpers/utils'
import simple_premium_1m_7_99_1m_44_usd from '@/data/products/subscription/prd_kpa6dHjrPsvW'
import simple_premium_1m_9_99_1m_44_usd from '@/data/products/subscription/prd_sbY0NWq9GMkz'
import simple_premium_3m_15_99_3m_79_usd from '@/data/products/subscription/prd_zMxVF811QQ0P'
import simple_premium_3m_19_99_3m_79_usd from '@/data/products/subscription/prd_kvFfWmOs3D4D'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				products: [
					{
						idents: {
							discounted: simple_premium_1m_9_99_1m_44_usd.ident,
							fallback: simple_premium_1m_7_99_1m_44_usd.ident,
						},
						default: true,
					},
					{
						idents: {
							discounted: simple_premium_3m_19_99_3m_79_usd.ident,
							fallback: simple_premium_3m_15_99_3m_79_usd.ident,
						},
					},
				],
			},
			components: {
				// срезаем первый продукт (1w) из items базы
				PaywallPlanPickerComp: (args): PaywallComponentProps.PlanPickerComp => {
					const base = schema.components.PaywallPlanPickerComp(args)
					return {
						...base,
						items: base.items.slice(1),
					}
				},
			},
		},
	)
